import React, { useState } from 'react';
import MailboxPanel from './MailboxPanel';
import SetAsideEmails from './SetAsideEmails';

const QUIET = { shown: false, attention: false };

/**
 * Emailed invoices, folded away: the mailbox and the set-aside emails sit in one closed line, which opens by itself when
 * either needs a person. Both stay mounted while it is closed, because they are what can tell it to open.
 */
export default function MailPanels({ tick, onChanged }) {
  const [mailbox, setMailbox] = useState(QUIET);
  const [setAside, setSetAside] = useState(QUIET);
  const [opened, setOpened] = useState(false);
  const attention = mailbox.attention || setAside.attention;
  return (
    <details data-testid="invoice-mail-panels" hidden={!mailbox.shown && !setAside.shown} open={attention || opened}
      onToggle={(e) => setOpened(e.currentTarget.open)}
      className="rounded-lg border border-surface-border bg-surface px-3 py-2 text-sm">
      <summary className="cursor-pointer select-none text-ink" data-testid="invoice-mail-summary">Emailed invoices</summary>
      <div className="mt-3 space-y-3">
        <MailboxPanel tick={tick} onChanged={onChanged} onStatus={setMailbox} />
        <SetAsideEmails tick={tick} onChanged={onChanged} onStatus={setSetAside} />
      </div>
    </details>
  );
}
